<template>
  <div class="publication-container">
    <div class="item-container">
      <div class="item-background"></div>
      <div class="title-line">新闻 NEWS</div>
      <div class="publication-content">
        <span class="blue-tag">2022.12</span>
        <br />
        实验室论文“Efficient and Effective Academic Expert Finding on
        Heterogeneous Graphs through (k,P)-Core based Embedding. Transactions on
        Knowledge Discovery from Data
        (TKDD)”被<strong>数据挖掘领域顶刊TKDD</strong>录用！探索了基于学术社区与文档语义相结合的专家发现技术！
        <br /><br />
        <span class="blue-tag">2022.12</span>
        <br />
        实验室牵头申报的<strong>浙江省尖兵领雁研发攻关计划项目</strong>获得立项！
        <br /><br />
        <span class="blue-tag">2022.03</span>
        <br />
        实验室论文“Aggregate Queries on Knowledge Graphs: Fast Approximation
        with Semantic-aware Sampling”被数据库领域<strong
          >CCF A类会议ICDE 2022 </strong
        >录用！首次探索了知识图谱上的近似聚集查询问题！ <br /><br />
        <span class="blue-tag">2021.09</span>
        <br />
        实验室论文“Academic Expert Finding via (K,P)-Core based Embedding over
        Heterogeneous Graphs”被数据库领域
        <strong>CCF A类会议ICDE 2022</strong>
        录用！该论文为本次会议少数几篇在第一轮投稿中获得提前录用的文章！
        <br /><br />
        <span class="blue-tag">2021.09</span>
        <br />
        实验室团队与<strong>之江实验室</strong>合作立项一项<strong>浙江省重点扶持项目“未来实验室数字化管理和科研辅助工具平台”</strong>，助力浙江省科技服务领域的数字化改革！
        <br /><br />
        <span class="blue-tag">2021.06</span>
        <br />
        实验室论文“A Comprehensive Survey and Experimental Comparison of
        Graph-Based Approximate Nearest Neighbor Search”被数据库领域<strong>
          CCF A类会议VLDB 2021 </strong
        >录用！该论文受到审稿专家高度好评：“这篇论文将在学术界和工业界产生很大的影响”！
        <br /><br />
        <span class="blue-tag">2021.07</span>
        <br />
        实验室论文“Two-Stage Routing with Optimized Guided Search and Greedy
        Algorithm on Proximity Graph”被人工智能领域CCF B类期刊Knowledge-based
        Systems录用！
        <br /><br />
        <span class="blue-tag">2020.11</span>
        <br />
        实验室论文“Top-k star queries on knowledge graphs through semantic-aware
        bounding match scores”被人工智能领域CCF B类期刊Knowledge-based
        Systems录用！
        <br /><br />
        <span class="blue-tag">2021.01</span>
        <br />
        实验室获批1项浙江省重点研发计划项目，聚焦公共安全智能防控，助力杭州亚运2022！
        <br /><br />
        <span class="blue-tag">2020.09</span>
        <br />
        实验室获批1项<strong>国家自然科学基金面上项目</strong>“语义驱动的知识图谱近似图查询关键技术研究”！
        <br /><br />
        <span class="blue-tag">2020.01</span>
        <br />
        实验室论文“Semantic Guided and Response Times
        <br />
        Bounded Top-k Similarity Search over Knowledge Graphs”被数据库领域
        <strong>CCF A类会议ICDE 2020 </strong>录用！
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.documentElement.scrollTop = 0;
  },
};
</script>

<style scoped>
.publication-container {
  min-height: 100vh;
}
.item-background {
  height: 60px;
}
.item-container {
  width: 60%;
  margin: 0px auto;
}
.title-line {
  margin: 32px auto;
  font-family: Microsoft YaHei;
  font-size: 40px;
  font-weight: 300;
  color: #333;
  text-align: center;
}
.publication-content {
  font-size: 20px;
  /* font-weight: bold; */
  line-height: 36px;
}
.blue-tag {
  font-weight: bold;
  font-size: 20px;
  color: rgb(39, 103, 187);
}
@media screen and (max-width: 900px) {
  .item-container {
    width: 80%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/news/index.vue